import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PendingSignatures from '../components/PendingSignatures.tsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PendingSignaturesPage: React.FC = () => {
  const [totalCount, setTotalCount] = useState<number>(0);

  // Function to receive count updates from the PendingSignatures component
  const handleCountUpdate = (count: number) => {
    setTotalCount(count);
  };

  return (
    <div className="container-app py-6">
      <ToastContainer position="top-right" autoClose={3000} />
      
      <div className="flex items-center mb-6">
     
        <h1 className="text-2xl font-bold">Pending Signatures</h1>
      </div>
      
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded mb-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-yellow-800">
              These tasks are completed but still pending customer signatures. Send reminders to customers or view task details.
            </p>
          </div>
        </div>
      </div>
      
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold">All Pending Signatures</h2>
     
      </div>
      
      <PendingSignatures limit={20} showViewAll={false} onCountUpdate={handleCountUpdate} />
      
      <div className="mt-4 text-center text-sm text-gray-600">
        <p>Scroll down to load more items automatically</p>
      </div>
    </div>
  );
};

export default PendingSignaturesPage; 